<template>
    <div class="dashboard">
        <v-responsive class="ml-auto" max-width="344">
            <v-text-field v-model="search" hide-details="auto" label="Search" clearable ></v-text-field>
        </v-responsive>
        <!-- <b-alert variant="primary" :show="keys.length > 0" class="d-flex justify-content-between align-items-center">
            <span>{{ keys.length }} item terpilih</span>
            <div>
                <ButtonComponent :colors="'#0072BC'" name="tanpaicon" customico="" Title="Setujui" @click.native="onSubmit(1)" />
                <ButtonComponent :colors="'#DC0000'" name="tanpaicon" customico="" Title="Tolak" @click.native="onSubmit(2)" />
            </div>
        </b-alert> -->
        <v-data-table :headers="header" :items="desserts" :search="search">
            <template v-slot:item.no="{ item }">
                {{ item.no }}
            </template>
            <template v-slot:item.status="{ item }">
                {{ (item.status == 1) ? 'Diterima' : '' }}
            </template>
            <template v-slot:item.action="{ item }">
                <div class="d-flex mt-2 mb-2">
                    <ButtonComponent colors="#FFBF00" name="eye" dataTitleTooltip="Lihat" v-b-modal.modalDaftar @click.native="openModal('detail', item)" />
                    <!-- <ButtonComponent colors="#3751E4" name="edit" dataTitleTooltip="Lihat" v-b-modal.modal2 @click.native="openModal('edit', item)" /> -->
                </div>
            </template>
        </v-data-table>
        
        <b-modal id="modalDaftar" :title="`Detail Berkas - ${(keys.length > 1)?  `${keys.length} Item Terpilih` : request.nama}`" size="lg">
            <!-- <div v-if="keys.length > 1">
                <div v-for="(item, index) in keys" :key="index" :class="(index == 0) ? '' : 'pt-4'">
                    {{ item.nama }}
                    <v-data-table :headers="headerModal" :items="dataModal" show-select v-model="keys" :item-key="itemKey" :selected="selectedKey">
                        <template v-slot:item.degree="{ item }">
                            {{ item.degree.toUpperCase() }}
                        </template>
                        <template v-slot:item.certificate_path="{ item }">
                            <span @click="downloadItem(item.certificate_path)" class="cursor-hand">{{ item.certificate_path }}</span>
                        </template>
                    </v-data-table>
                </div>
            </div> -->
            <div>
                <v-data-table :headers="headerModal" :items="dataModal" show-select v-model="keys" :item-key="itemKey" :selected="selectedKey">
                    <template v-slot:item.degree="{ item }">
                        {{ item.degree.toUpperCase() }}
                    </template>
                    <template v-slot:item.certificate_path="{ item }">
                        <span @click="downloadItem(item.certificate_path)" class="cursor-hand">{{ item.certificate_path }}</span>
                    </template>
                </v-data-table>
            </div>
            <template #modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="primary" @click="approve(1)">
                    Setujui
                </b-button>
                <b-button size="sm" variant="danger" @click="approve(2)">
                    Tolak
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style scoped>
  .cursor-hand{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
</style>

<script>
import ButtonComponent from '@/view/content/components/button/buttonComponent.vue';
import axios from 'axios';

export default {
    name: 'SiakNgFrontEndBerkas',

    data() {
        return {
            amountList: [
                {
                    title: 'Menunggu Persetujuan',
                    amount: 10,
                    color: 'bg-warning',
                    customico: 'clock',
                    borders: 'border-warning',
                    iconsize: 'font-size: 600%'
                },
                {
                    title: 'Diterima',
                    amount: 679,
                    color: 'bg-primary',
                    customico: 'check2-circle',
                    borders: 'border-primary',
                    iconsize: 'font-size: 600%'
                },
                {
                    title: 'Ditolak',
                    amount: 5,
                    color: 'bg-danger',
                    customico: 'x-circle',
                    borders: 'border-danger',
                    iconsize: 'font-size: 600%'
                },
            ],
            header: [
                { text: "Nama", value: "nama" },
                { text: "NOAK", value: "noal" },
                { text: "Prodi", value: "prodi" },
                { text: "Angkatan", value: "angkatan" },
                { text: "Tingkat", value: "tingkat" },
                { text: "Tahun Akademik", value: "tahunAkademik" },
                { text: "Kelas", value: "kelas" },
                { text: "Aksi", value: "action" },
            ],
            desserts: [],
            search: '',
            headerModal: [
                { text: "No", value: "no" },
                { text: "Jenjang Studi", value: "degree" },
                { text: "Nama Institusi", value: "institute" },
                { text: "Tahun Lulus", value: "graduation_year" },
                { text: "Ijazah", value: "certificate_path" },
            ],
            dataModal: [],
            request: {
                key: null,
                kelas: '',
                nama: '',
                noal: '',
                prodi: null,
                tahunAkademik: '',
                tingkat: '',
            },
            keys: [],
            itemKey: 'key',
            selectedKey: 'key',
        };
    },

    components: {
        ButtonComponent,
    },

    mounted() {
        this.getData()
    },
    computed:{
        selectedKeys(){
            return this.keys.map(keys => keys.key);
        }
    },
    methods: {
        async tolak(status){
            try {
                // let form = this.request;
                let formData = {}
                if (this.selectedKeys.length > 1) {
                    formData = {
                        id_siswa: this.selectedKeys,
                        status_berkas: status
                    }    
                }else{
                    formData = {
                        id_siswa: [this.request.key],
                        status_berkas: status
                    }    
                }
                
                const result = await axios.post(`master/student-education/approve-berkas/`, formData)
                this.refreshData(result, 'Update')
            } catch (error) {
                this.$swal('Failed')
            }
            this.$bvModal.hide('modalDaftar')
        },
        async approve(status){
            try {
                // let form = this.request;
                let formData = {}
                    formData = {
                        key_berkas: this.selectedKeys,
                        status_berkas: status
                    }
                
                const result = await axios.post(`master/student-education/approve-berkas/`, formData)
                this.refreshData(result, 'Update')
            } catch (error) {
                this.$swal('Failed')
            }
            this.$bvModal.hide('modalDaftar')
        },
        changeurl(data, status){
            let propsData = {
                ...data,
                aksi: status
            };
            // this.$router.push({ path:'/pengaduan/detail', params: {propsData: data} });
            this.$router.push({ name:'Detail-Pengaduan', params: {propsData: propsData} });
        },

        async openModal(status,itemData = null) {
            this.request = {
                kelas: '',
                nama: '',
                noal: '',
                prodi: '',
                tahunAkademik: '',
                tingkat: '',
            }
            this.keys = [];
            if (status == 'detail') {
                if (this.keys.length > 1) {
                    let formData = {
                        multi_student: this.selectedKeys,
                        status_berkas: 0
                    }
                    const details = await axios.post(`master/student-education/detail-berkas`, formData);
                    details.data.data.forEach(dokumen => {
                        this.request.nama = dokumen.nama;
                        this.dataModal = dokumen.dokumen.map((item, index) => ({
                            ...item,
                            no: index+1,
                        }));
                    });
                }else{
                    let formData = {
                        multi_student: [itemData.key],
                        status_berkas: 0
                    }
                    const details = await axios.post(`master/student-education/detail-berkas`, formData);
                    details.data.data.map(detail => {
                        this.request.key = detail.key;
                        this.request.nama =  detail.nama;
                        this.dataModal = detail.dokumen.map((item, index) => ({
                            ...item,
                            no: index+1,
                        }));
                    });
                }
            }
        },

        async getData(){
            if (this.desserts.length > 0) {
                this.desserts = []
            }
            const result = await axios.get('master/student-education/index/?status_berkas=0');
            result.data.data.map((peng, index) => {
                let data = {
                    no: index+1,
                    nama: peng.student_name,
                    noal: peng.nim,
                    prodi: peng.prodi,
                    // angkatan: peng.
                    tingkat: peng.tingkat_siswa,
                    tahunAkademik: peng.tahun_akademik,
                    kelas: peng.nama_kelompok,
                    key: peng.key,
                };
                this.desserts.push(data);
            });
        },

        refreshData(result, alert) {
            if (result.data.meta.code == 200) {
                this.keys = [];
                this.$swal(`Success ${alert} Data`);
                this.mhs = []
                this.getData();
                this.$emit('refreshTabs');
                // window.location.reload();
            } else {
                this.$swal(`Failed`);
            }
        },

        async getRoom(){
            try {
                let room = await axios.get(`master/rooms`);
                room.data.data.map((ruangs) => {
                    let ruangan = { id: ruangs.key, text: ruangs.room_name };
                    this.ruang.push(ruangan);
                })
            } catch (error) {
                this.$swal('Failed')
            }
        },

        changeruang(selected){
            this.request.tempat = selected;
        },

        async onSubmit(status) {
            try {
                // let form = this.request;
                let formData = {
                    id_siswa: this.selectedKeys,
                    status_berkas: status
                }
                
                const result = await axios.post(`master/student-education/approve-berkas/`, formData)
                this.refreshData(result, 'Update')
            } catch (error) {
                this.$swal('Failed')
            }
        },

        changeStatus: function (selected) {
            this.request.status = selected;
            if (selected == 3) {
                this.status_penempatan = true
            } else {
                this.status_penempatan = false
            }
        },

        downloadItem(label) {
            const externalRouteUrl = this.$endpoint + 'uploads/student_graduation_certificate/' + label;
            window.open(externalRouteUrl, '_blank');
        },
    },
};
</script>

<style scoped>
    .text-green {
        color: #006B8C;
    }

    .spacer{
        width: 10px;
        display: inline-block;
    }

    .flex{
        display: flex;
    }
</style>